import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/shared.css";
import "@/styles/inventory.css";
import "@/styles/accounts-and-detail.css";
import "@/styles/dialogs-analysis.css";
import "@/styles/finance.css";
import "@/styles/employees.css";
import App from "@/App";

const resizeObserverLoopMessages = new Set([
  "ResizeObserver loop completed with undelivered notifications.",
  "ResizeObserver loop limit exceeded",
]);

function dismissResizeObserverOverlay() {
  window.requestAnimationFrame(() => {
    document.getElementById("webpack-dev-server-client-overlay")?.remove();
    document.getElementById("webpack-dev-server-client-overlay-div")?.remove();
  });
}

window.addEventListener("error", (event) => {
  if (resizeObserverLoopMessages.has(event.message)) {
    event.preventDefault();
    event.stopImmediatePropagation();
    dismissResizeObserverOverlay();
  }
}, true);

window.addEventListener("unhandledrejection", (event) => {
  const message = event.reason?.message || String(event.reason || "");

  if (resizeObserverLoopMessages.has(message)) {
    event.preventDefault();
    dismissResizeObserverOverlay();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />,
);
